import type { BuslineData, priceRule } from "./datatypes";
class BuslineItem {
  constructor(public data: BuslineData) { 
    this.data = data; 
  }
  public getPrice(birthDate: Date): priceRule {
    if (!this.data || !this.data.priceRules || !birthDate) {
      return {
        priceOneWay: 1E3,
        priceRoundTrip: 1E3,
        priceNoTrip: 1E3,
        ageMax: 0,
        dateMax: new Date()
      };
    }
    const calculateAge = (birthDate: Date) => {
      const today = new Date();
      const birth = new Date(birthDate);
      let age = today.getFullYear() - birth.getFullYear();
      const m = today.getMonth() - birth.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
        age--;
      }
      return age;
    };
    const person_age = calculateAge(birthDate);
    const ages = this.data.priceRules.map(price => price.ageMax);
    const selectedages = ages.filter(age => age >= person_age);
    const lowestagemax = Math.min(
      ...selectedages
    );
    return this.data.priceRules.find(price => price.ageMax === lowestagemax) || {
      priceOneWay: 1E3,
      priceRoundTrip: 1E3,
      priceNoTrip: 1E3,
      ageMax: 0,
      dateMax: new Date()
    };
  }
}
export default BuslineItem;
